import React, { ChangeEventHandler, useState } from "react";

import { setHours, setMinutes } from "date-fns";
import { DayPicker } from "react-day-picker";
import { bg, enUS } from "react-day-picker/locale";


export const formatDate = (d: any) => {
  const lang = localStorage.getItem('lngPref') ? localStorage.getItem('lngPref') : "bg";
  const weekdayEn = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const weekdayBg = ["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"];
  const monthNamesEn = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const monthNamesBg = ["Януари", "Февруари", "Март", "Април", "Май", "Юни",
    "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"
  ];
  let weekday = lang === "bg" ? weekdayBg : weekdayEn; 
  let date: Date = new Date(d);
  let day = weekday[date.getDay()];
  let mDate = date.getDate();
  let month:any = lang === "bg" ? monthNamesBg[d.getMonth()] : monthNamesEn[d.getMonth()];
  //const suff = lang === "bg" ? "ти": "th";
  //console.log(day);
  return day + ", " + mDate + " " + month;
}

export function DateTimePicker(props: any) {
  let [selected, setSelected] = useState<Date>() || "";
  let [timeValue, setTimeValue] = useState<string>("00:00");
  const lang = localStorage.getItem('lngPref') ? localStorage.getItem('lngPref') : "bg";
  const localeType = lang === "bg" ? bg : enUS;
  const handleTimeChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const time = e.target.value;
    if (!selected) {
      setTimeValue(time);
      sendData();
      return;
    }
    const [hours, minutes] = time.split(":").map((str) => parseInt(str, 10));
    const newSelectedDate = setHours(setMinutes(selected, minutes), hours);
    setSelected(newSelectedDate);
    timeValue = time;
    setTimeValue(time);
    sendData();
  };

  const handleDaySelect = (date: Date | undefined) => {
    if (!timeValue || !date) {
      setSelected(date);
      return;
    }
    const [hours, minutes] = timeValue
      .split(":")
      .map((str) => parseInt(str, 10));
    const newDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      minutes
    );
    selected = newDate;
    setSelected(newDate);
    sendData();
  };

  const sendData = () => {
    if(props.getData) {
      const dataObject = {
        date: selected,
        time: timeValue
      }
      props.getData(dataObject);
    }
  }

  return (
    <div className="flex-box calendar-out">
      <div>
        <DayPicker
          mode="single"
          selected={selected}
          onSelect={handleDaySelect}
          locale={localeType}
          // footer={`Selected date: ${
          //   selected ? selected.toLocaleString() : "none"
          // }`}
        />
      </div>
      <div>
        <form style={{ marginBlockEnd: "1em" }}>
          <label>
            <span>
              {selected ? formatDate(selected) : ""}
            </span>
            <br />
            <input type="time" value={timeValue} onChange={handleTimeChange} />
          </label>
        </form>
      </div>
    </div>
  );
}